/**
 * Pure helpers for step data derivation.
 * Single Responsibility: extract step state from wizard status (testable, no side effects).
 */

/**
 * Get step data (isEnabled, stats) for a step number from wizard status.
 * @param {Object|null} wizardStatus
 * @param {number} stepNumber
 * @returns {{ isEnabled: boolean, stats: Object }}
 */
export function getStepData(wizardStatus, stepNumber) {
  const step = wizardStatus?.steps?.find((s) => s.step === stepNumber);
  const isFirst = stepNumber === 1;
  return {
    isEnabled: step?.isEnabled ?? isFirst,
    stats: step?.stats ?? {},
  };
}
